import styled, { css } from 'styled-components/macro';

import Row from 'components/data-visualization/Table/Row';
import Cell from 'components/data-visualization/Table/Cell';
import { ReactComponent as Caret } from 'icons/icon-toggle-caret.svg';
import BaseArtwork from 'components/base/Artwork/Artwork';
import NoDataBase from 'components/styled/NoData/NoData';
import { Link as RouterLink } from 'react-router-dom';
import { EntityCell } from 'components/data-visualization/Table/DoubleMetricCell.style';
import Box from 'components/elements/Box';
import { MenuRoot } from 'components/base/Menu/index';

import modularScale from 'styles/helpers/modular-scale';
import { definitionLabel } from 'styles/base-classes';

interface IObject {
  [key: string]: any;
}

export const TableRow = styled(Row)<IObject>`
  display: flex;
  flex-flow: row wrap;
  font-size: ${modularScale(-1)};

  ${EntityCell} {
    flex-basis: 95%;
  }

  ${({ theme, withExpandableRows, isStatic }) => css`
    padding: ${theme.spacing.small};
    cursor: ${withExpandableRows ? 'pointer' : 'initial'};
    background: ${isStatic ? theme.LightGrey : 'initial'};
    border-bottom: 1px solid ${theme.Grey};
  `}

  @media screen and (min-width: 50em) {
    display: table-row;
    td {
      border-bottom: 1px solid ${(p) => p.theme.Grey};
    }
  }
`;

export const TableCell = styled(Cell)`
  display: flex;
  align-items: center;
  padding: 0;
  ${({ theme }) => css`
    font-family: ${theme.numbersTypography};
    @media screen and (min-width: 50em) {
      display: table-cell;
      padding: ${modularScale(-2)} ${theme.spacing.small} !important;
    }
  `}
`;

export const PositionCell = styled(TableCell)`
  font-family: ${({ theme }) => theme.primaryTypography};
  flex: 0 0 auto;
  padding: 0.5em;
  font-size: ${modularScale(1)};
  white-space: nowrap;
  text-align: center;

  &:before {
    content: '#';
    display: inline-block;
  }

  @media screen and (min-width: 50em) {
    width: 2em;
  }
`;

export const CountryCell = styled(TableCell)`
  font-weight: 600;
  max-width: 200px;
`;

export const ExpandCell = styled(TableCell)`
  order: 3;
  margin-left: auto;

  @media screen and (min-width: 50em) {
    order: initial;
  }
`;

export const AlignContent = styled('div')<IObject>`
  display: flex;
  align-items: center;
  justify-content: ${({ alignLeft, center }) =>
    alignLeft ? 'flex-start' : center ? 'center' : 'flex-end'};
`;

export const ExpandedTableRow = styled(TableRow)`
  background: ${({ theme }) => theme.Sand};
  padding-bottom: 0;
  border-bottom: 0;
`;

export const StyledCaret = styled(Caret)<IObject>`
  ${({ theme, open }) => css`
    transition-timing-function: ${theme.timingFunction}
    transition-duration: ${theme.transitionDuration};
    transform: ${open ? 'rotate(180deg)' : 'rotate(0)'};
  `}
`;

export const List = styled.ul`
  column-span: all;
  display: flex;
  flex-wrap: wrap;
`;

export const ListItem = styled.li`
  flex: 1;
  min-width: 100%;
  max-width: 20em;
  display: flex;
  align-items: center;
  margin: ${({ theme }) => `${theme.spacing.large} ${theme.spacing.xxlarge}`};

  @media screen and (min-width: 50em) {
    min-width: 20em;
  }

  p {
    margin: 0;

    &:first-of-type {
      font-weight: 600;
    }

    &:nth-of-type(2) {
      color: ${({ theme }) => theme.CasperGrey};
    }
  }
`;

export const Label = styled('span')`
  ${definitionLabel};
  font-size: 11px;
  font-family: ${({ theme }) => theme.primaryTypography};
  display: block;
  margin-left: ${({ theme }) => theme.spacing.xxlarge};
  padding-top: ${({ theme }) => theme.spacing.small};
`;

export const Artwork = styled(BaseArtwork)`
  width: ${modularScale(6)} !important;
  height: ${modularScale(6)} !important;
  margin-right: ${({ theme }) => theme.spacing.small};
`;

export const NoData = styled(NoDataBase)`
  margin: ${({ theme }) => theme.spacing.medium} auto;
`;

export const NoSearchResults = styled.p`
  span {
    font-weight: 600;
  }
`;

export const Link = styled(RouterLink)`
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${({ theme }) => theme.DeepBlue};
  }
`;

export const SalesTypeDropdownWrapper = styled(Box)`
  ${MenuRoot} {
    margin-left: 0;
  }
`;
